"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var sheet_1 = __importDefault(require("../views/sheet"));
var game_area_1 = require("../utilities/game-area");
var feed_food_button_1 = __importDefault(require("../views/feed-food-button"));
var stack_container_1 = __importStar(require("../views/stack-container"));
var food_1 = require("../models/food");
var calculator_1 = require("../models/calculator");
var color_1 = require("../utilities/color");
var filter_glow_1 = require("@pixi/filter-glow");
var i18next_1 = __importDefault(require("i18next"));
var gsap_1 = require("gsap");
var PixiPlugin_1 = require("gsap/PixiPlugin");
var MotionPathPlugin_1 = require("gsap/MotionPathPlugin");
gsap_1.gsap.registerPlugin(PixiPlugin_1.PixiPlugin, MotionPathPlugin_1.MotionPathPlugin);
PixiPlugin_1.PixiPlugin.registerPIXI(PIXI);
var FeedState = /** @class */ (function (_super) {
    __extends(FeedState, _super);
    function FeedState(app, client, backdropContainer, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._backdropContainer = backdropContainer;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(FeedState.prototype, "backButton", {
        get: function () {
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, this.hideSheet.bind(this));
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("feed_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "sheet", {
        get: function () {
            if (!this._sheet) {
                this._sheet = new sheet_1.default(this._app.loader.resources.ui.textures);
                this._sheet.contentContainer.addChild(this.foodContainer);
            }
            return this._sheet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "foodButtons", {
        get: function () {
            if (!this._foodButtons) {
                this._foodButtons = [];
                for (var i = 0; i < 8; i++) {
                    var button = new feed_food_button_1.default(this.onFood.bind(this));
                    this._foodButtons.push(button);
                }
            }
            return this._foodButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "foodContainer", {
        get: function () {
            if (!this._foodContainer) {
                this._foodContainer = stack_container_1.default.Group(this.foodButtons, 4, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: -8,
                }, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: -8,
                    minWidth: game_area_1.GAME_WIDTH
                });
            }
            return this._foodContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "foodSprite", {
        get: function () {
            if (!this._foodSprite) {
                this._foodSprite = new PIXI.Sprite();
                this._foodSprite.anchor.set(0.5);
                this._foodSprite.interactive = true;
                this._foodSprite
                    .on("pointerdown", this.onDragStart.bind(this))
                    .on("pointerup", this.onDragEnd.bind(this))
                    .on("pointerupoutside", this.onDragEnd.bind(this));
            }
            return this._foodSprite;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    align: "center",
                    fontSize: 35,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "tipLabel", {
        get: function () {
            if (!this._tipLabel) {
                this._tipLabel = new PIXI.Text("");
                this._tipLabel.style = {
                    fontFamily: "Arial",
                    fontSize: 21,
                    fill: color_1.COLOR.GREEN
                };
            }
            return this._tipLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.tipLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 6,
                    minWidth: game_area_1.GAME_WIDTH
                });
                this._stackContainer.position.set(0, game_area_1.GAME_SAFE_AREA.bottom - this._stackContainer.height - 10);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    FeedState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this._backdropContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.stackContainer);
        this._app.stage.addChild(this.sheet);
        this._dragonContainer.setIdleAnimation();
        this._backdropContainer.dragonSlot.addChild(this._dragonContainer);
        this.showSheet();
        this.titleLabel.text = "";
        this.tipLabel.text = "";
        this.stackContainer.layoutChildren();
        this._client.sendEvent("feed_entered");
    };
    FeedState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this._backdropContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.stackContainer);
        this._app.stage.removeChild(this.sheet);
        this._backdropContainer.dragonSlot.removeChild(this._dragonContainer);
    };
    FeedState.prototype.showSheet = function () {
        this.updateFoods();
        this.sheet.show(false, false);
        this.sheet.show(true, true);
    };
    FeedState.prototype.hideSheet = function () {
        var _this = this;
        this.sheet.show(false, true, function () {
            _this.stateMachine.pop();
        });
    };
    FeedState.prototype.updateFoods = function () {
        for (var i = 0; i < this.foodButtons.length; i++) {
            var button = this.foodButtons[i];
            if (i >= food_1.FOOD_CHOICES.length) {
                button.setTexture(null);
                continue;
            }
            var food = food_1.FOOD_CHOICES[i];
            var texture = this._app.loader.resources.ui.textures["feed_" + food + ".png"];
            button.setTexture(texture);
        }
    };
    FeedState.prototype.onFood = function (button) {
        var index = this.foodButtons.indexOf(button);
        if (index >= food_1.FOOD_CHOICES.length) {
            return;
        }
        this._food = food_1.FOOD_CHOICES[index];
        this.sheet.show(false, true);
        this.foodSprite.scale.set(1.5);
        this.foodSprite.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_SAFE_AREA.bottom - 150);
        this.foodSprite.filters = [
            new filter_glow_1.GlowFilter({
                distance: 28,
                outerStrength: 2.6
            })
        ];
        this.foodSprite.texture = this._app.loader.resources.ui.textures["feed_" + this._food + ".png"];
        this._app.stage.addChild(this.foodSprite);
        gsap_1.gsap.fromTo(this.foodSprite, {
            pixi: { rotation: -15 }
        }, {
            pixi: { rotation: 15 },
            duration: 1,
            repeat: -1,
            yoyo: true,
            ease: "Power1.easeInOut"
        });
        this.titleLabel.text = "";
        this.tipLabel.text = i18next_1.default.t("feed_hint");
        this.stackContainer.layoutChildren();
    };
    FeedState.prototype.onDragStart = function (event) {
        this._interactionData = event.data;
    };
    FeedState.prototype.onDragEnd = function () {
        var position = this._interactionData.getLocalPosition(this._app.stage);
        var vector = new PIXI.Point(position.x - this.foodSprite.x, position.y - this.foodSprite.y);
        this._interactionData = null;
        if (vector.y > 0) {
            return;
        }
        if (vector.y > -50) {
            return;
        }
        this.foodSprite.filters = null;
        if (Math.abs(vector.y) >= 250) {
            vector.x = Math.max(vector.x, -200);
            vector.x = Math.min(vector.x, 200);
            vector.y = -300;
            var startPosition = this.foodSprite.position;
            var endPosition = this._app.stage.toLocal(this._dragonContainer.getMouthPosition(), this._dragonContainer);
            var midPosition = new PIXI.Point(startPosition.x + vector.x, startPosition.y + vector.y);
            var groundPosition = this._app.stage.toLocal(this._dragonContainer.position, this._dragonContainer);
            gsap_1.gsap.to(this.foodSprite, {
                duration: 1,
                motionPath: {
                    path: [
                        { x: startPosition.x, y: startPosition.y },
                        { x: midPosition.x, y: midPosition.y },
                        { x: endPosition.x, y: endPosition.y }
                    ]
                },
                pixi: {
                    scale: 0.5,
                    rotation: 360
                },
                onComplete: this.congratulate.bind(this)
            });
        }
        else {
            vector.x = Math.max(vector.x, -100);
            vector.x = Math.min(vector.x, 100);
            vector.y = -250;
            var startPosition = this.foodSprite.position;
            var endPosition = this._app.stage.toLocal(this._dragonContainer.getMouthPosition(), this._dragonContainer);
            var midPosition = new PIXI.Point(startPosition.x + vector.x, startPosition.y + vector.y);
            var groundPosition = this._app.stage.toLocal(this._dragonContainer.position, this._dragonContainer);
            var bounce = new PIXI.Point(midPosition.x + vector.x, groundPosition.y);
            gsap_1.gsap.to(this.foodSprite, {
                duration: 1.3,
                motionPath: {
                    path: [
                        { x: startPosition.x, y: startPosition.y },
                        { x: midPosition.x, y: midPosition.y },
                        { x: bounce.x, y: bounce.y },
                        { x: endPosition.x, y: endPosition.y }
                    ]
                },
                pixi: {
                    scale: 0.5,
                    rotation: 360
                },
                onComplete: this.congratulate.bind(this)
            });
        }
    };
    FeedState.prototype.congratulate = function () {
        var _this = this;
        this._app.stage.removeChild(this.foodSprite);
        var points = calculator_1.FEED_XP;
        this.titleLabel.text = i18next_1.default.t("feed_finish_caption");
        this.tipLabel.text = i18next_1.default.t("feed_finish_hint")
            .replace("[points]", points.toFixed());
        this.stackContainer.layoutChildren();
        this._client.adjustMeters({
            calmness: 0,
            nutrition: 15,
            hygiene: 0,
            energy: 0
        });
        this._client.award(points);
        this._client.synchronize();
        this._client.sendEvent("feed_finished", {
            food: this._food
        });
        gsap_1.gsap.to(this, {
            duration: 2,
            onComplete: function () {
                _this.stateMachine.pop();
            }
        });
    };
    return FeedState;
}(state_1.default));
exports.default = FeedState;
